import { createSlotRecipe } from './runtime.js';

const drawerConfig = {"name":"drawer","slots":["root","overlay","content","contentInner","header","title","description","body","footer","close"],"defaultVariants":{"size":"lg"},"variantMap":{"contained":["true"],"size":["custom","lg","md"]}}

export const drawer = /* @__PURE__ */ createSlotRecipe(drawerConfig)